const vesselCategories = [
  { maxDWT: 60000, category: "SMALL" },
  { maxDWT: 80000, category: "PANAMAX" },
  { maxDWT: 120000, category: "AFRAMAX" },
  { maxDWT: 200000, category: "SUZEMAX" },
  { maxDWT: 99999999999, category: "VLCC" },
];

export const getVesselCategory = (deadWeightTonage: number) => {
  if (!deadWeightTonage) {
    return "";
  }

  return vesselCategories.find(({ maxDWT }) => deadWeightTonage <= maxDWT)?.category ?? "";
};
